import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default, { useMemo } from 'react';
import { c as classNames } from '../../../shared/index-324f55b0.js';
import { useUniqueId } from './hooks/useId.js';
import { useProgressIndicator } from './hooks/useProgressIndicator.js';
import { getDisplayName } from '../../../utils/getDisplayName.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "progress-indicator": "web_ui__ProgressIndicator__progress-indicator",
  "horizontal": "web_ui__ProgressIndicator__horizontal",
  "default": "web_ui__ProgressIndicator__default",
  "narrow": "web_ui__ProgressIndicator__narrow",
  "tight": "web_ui__ProgressIndicator__tight",
  "wide": "web_ui__ProgressIndicator__wide",
  "vertical": "web_ui__ProgressIndicator__vertical"
};

var _excluded = ["styling", "size", "children", "testId"];
var cssClasses = classNames.bind(styles);
var ProgressIndicator = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _getDisplayName, _stepsAsChildren$prog;
  var _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? 'Default' : _ref$styling,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'Default' : _ref$size,
    children = _ref.children,
    testId = _ref.testId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var id = useUniqueId();
  var stepsAsChildren = React__default.Children.toArray(children);
  var direction = (_getDisplayName = getDisplayName(children)) !== null && _getDisplayName !== void 0 && _includesInstanceProperty(_getDisplayName).call(_getDisplayName, 'Vertical') ? 'vertical' : 'horizontal';
  var progressIndicatorValues = useMemo(function () {
    return {
      direction: direction,
      steps: _mapInstanceProperty(stepsAsChildren).call(stepsAsChildren, function (step) {
        return step.props;
      })
    };
  }, [direction, stepsAsChildren]);
  var progressIndicatorHook = useProgressIndicator(progressIndicatorValues);
  var contentProps = useMemo(function () {
    var _context, _progressIndicatorHoo, _context2, _progressIndicatorHoo2;
    return {
      role: 'tabpanel',
      id: _concatInstanceProperty(_context = "step-content-".concat(id, "-")).call(_context, ((_progressIndicatorHoo = progressIndicatorHook.stepProps[progressIndicatorHook.state.currentStep]) === null || _progressIndicatorHoo === void 0 ? void 0 : _progressIndicatorHoo.id) || ''),
      'aria-labelledby': _concatInstanceProperty(_context2 = "step-label-".concat(id, "-")).call(_context2, ((_progressIndicatorHoo2 = progressIndicatorHook.stepProps[progressIndicatorHook.state.currentStep]) === null || _progressIndicatorHoo2 === void 0 ? void 0 : _progressIndicatorHoo2.id) || ''),
      'aria-expanded': true
    };
  }, [id, progressIndicatorHook.state.currentStep, progressIndicatorHook.stepProps]);
  var items = useMemo(function () {
    return stepsAsChildren.reduce(function (acc, step, index) {
      var _progressIndicatorHoo3;
      acc.push(/*#__PURE__*/React__default.cloneElement(step, _objectSpread(_objectSpread({
        'aria-controls': "".concat(((_progressIndicatorHoo3 = progressIndicatorHook.stepProps[progressIndicatorHook.state.currentStep]) === null || _progressIndicatorHoo3 === void 0 ? void 0 : _progressIndicatorHoo3.id) || '')
      }, progressIndicatorHook.stepProps[index]), {}, {
        size: size
      })));
      return acc;
    }, []);
  }, [stepsAsChildren, progressIndicatorHook.state.currentStep, progressIndicatorHook.stepProps, size]);
  var stepContent = (_stepsAsChildren$prog = stepsAsChildren[progressIndicatorHook.state.currentStep]) === null || _stepsAsChildren$prog === void 0 || (_stepsAsChildren$prog = _stepsAsChildren$prog.props) === null || _stepsAsChildren$prog === void 0 ? void 0 : _stepsAsChildren$prog.children;
  var indicatorStyling = cssClasses(styling, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.default, styling === 'Default'), styles.tight, styling === 'Tight'), styles.narrow, styling === 'Narrow'), styles.wide, styling === 'Wide'));
  var containerClass = cssClasses(styles['progress-indicator'], styles[direction], indicatorStyling, size);
  var newGap = size === 'Small' ? 10 : 20;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", _objectSpread(_objectSpread(_objectSpread({
      className: containerClass,
      ref: ref
    }, progressIndicatorHook.progressIndicatorProps), rest), {}, {
      style: direction === 'horizontal' ? {
        gap: "".concat(newGap, "px")
      } : {},
      "data-testid": testId,
      children: items
    })), /*#__PURE__*/jsx("div", {
      children: direction === 'horizontal' ? /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, contentProps), {}, {
        children: [stepContent, " "]
      })) : null
    })]
  });
});
ProgressIndicator.displayName = 'ProgressIndicator';

export { ProgressIndicator };
//# sourceMappingURL=ProgressIndicator.js.map
